module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('v-header', {
    attrs: {
      "show_parent": _vm.show,
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-detail1"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    class: {
      active: _vm.active == 'done'
    },
    on: {
      "click": function($event) {
        _vm.toggle('done')
      }
    }
  }, [_vm._v("已读")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.active == 'will'
    },
    on: {
      "click": function($event) {
        _vm.toggle('will')
      }
    }
  }, [_vm._v("未读  " + _vm._s(_vm.message_count ? _vm.message_count : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 'done'),
      expression: "active==='done'"
    }],
    staticClass: "bottom markdown-body"
  }, _vm._l((_vm.has_read_message), function(item) {
    return _c('div', {
      staticClass: "message "
    }, [_c('div', {
      staticClass: "user"
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.author.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "cl"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author.loginname))]), _vm._v(" "), (item.type === 'at') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("在回复中@了您")]) : _vm._e(), _vm._v(" "), (item.type === 'reply') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("回复了您的话题")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "reply_content",
      domProps: {
        "innerHTML": _vm._s(item.reply.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "topic-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Topic',
          params: {
            id: item.topic.id
          }
        }
      }
    }, [_vm._v("\n              话题：" + _vm._s(item.topic.title) + "\n            ")])], 1)])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 'will'),
      expression: "active==='will'"
    }],
    staticClass: "bottom markdown-body"
  }, _vm._l((_vm.hasnot_read_message), function(item) {
    return _c('div', {
      staticClass: "message "
    }, [_c('div', {
      staticClass: "user"
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.author.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "cl"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author.loginname))]), _vm._v(" "), (item.type === 'at') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("在回复中@了您")]) : _vm._e(), _vm._v(" "), (item.type === 'reply') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("回复了您的话题")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "reply_content",
      domProps: {
        "innerHTML": _vm._s(item.reply.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "topic-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Topic',
          params: {
            id: item.topic.id
          }
        }
      }
    }, [_vm._v("\n              话题：" + _vm._s(item.topic.title) + "\n            ")])], 1)])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53beccbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Message.vue
// module id = 139
// module chunks = 1